export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/c28YBh5TbGDbhZohL6yWbn/IMG_2691.jpg',
    alt: 'Sample page: Work, Energy & Conservation Principles — a motor, coupling and pump showing how mechanical work is transmitted',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/k14sRBV4CiRrNwz9CmnJRa/IMG_2692.jpg',
    alt: 'Sample page: 3:1 Gear Reduction Example — direct drive versus gear reduction with speed, torque and efficiency values',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7nPaJhWNW6cQ8ykCmQ2CLg/IMG_2693.jpg',
    alt: 'Sample page: System Definition & Assumptions — motor and gearbox drivetrain with input torque, speed, reduction and efficiency',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hGWLbBpdfgRWgeQxin6Xs1/IMG_2694.jpg',
    alt: 'Sample page: Where Idealized Models Diverge from Reality — boundary conditions, friction, tolerances, fatigue and safety factors',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xAZobTjnV8UKnswqH9LMKG/IMG_2695.jpg',
    alt: 'Sample page: Engineering Judgment & Model Limitations — a simplified pump model compared with a real industrial installation',
  },
];
